import {formatMoney} from '@shopify/theme-currency';
import {Emitter} from './emitter';

const
    GIFT_CARD_PRODUCT_ID = 213559148556,
    BONUS_GIFT_CARD_PRODUCT_ID = 4444811493472,
    BONUS_GIFT_CARD_VARIANT_ID = 31609413533792,
    BONUS_GIFT_CARD_VALUE_CENTS = 10e2,
    BONUS_GIFT_CARD_PER_CENTS = 50e2;

export class Cart extends Emitter {
    constructor(api) {
        super();
        this.api = api;
        this.operation = null;
        this.data = null;
        this.item_count = null;
        this.current_item_count = null;
        this.handleCartData = this.handleCartData.bind(this);
        this.removeFromCartBaseOn = this.removeFromCartBaseOn.bind(this);
        this.fetch = this.fetch.bind(this);
        this.itemCountUpdate = this.itemCountUpdate.bind(this);
        this.specificProductInCart = ABV4_SETTINGS.specific_product_in_cart;

        this.removeFromCartBaseOn();
        $('#free-shipping-pronugget').on('hidden.bs.modal', function (e) {
            window.location.reload();
        })
    }

    fetch() {
        this.operation = this.api.cart().then(this.handleCartData);
        return this.operation;
    }

    update(data) {
        this.operation = this.api.cartUpdate(data).then(this.handleCartData);
        return this.operation;
    }

    addSingle(variantId, quantity) {
        const data = {items: [{id: variantId, quantity}]};
        this.operation = this.api.addToCart(data)
            .then(() => this.api.cart())
            .then(this.handleCartData);
        return this.operation;
    }

    handleCartData(data) {
        this.data = data;
        this.item_count = data.item_count;
        this.itemCountUpdate(data);
        this.emit('cartchange', data);

        return data;
    }

    getData() {
        if (this.operation === null)
            this.fetch();
        
    
        return this.operation;
    }
    
    itemCountUpdate(data) {
            let bundlesApplied = [];
            let itemCountResult = 0;
            for(const lineItem of data.items) {
                const { properties, quantity } = lineItem;
                const { _bundle_class, _base_product_qty, _single_product } = properties;

                if(lineItem.properties.hasOwnProperty('_bundle_class') && _single_product != 'true') {
                    const baseProductQty = parseFloat(_base_product_qty);
                    if(!bundlesApplied.hasOwnProperty(_bundle_class)) {
                        bundlesApplied[_bundle_class] = true;
                        let bundleQty = 1; 
                        if (baseProductQty === 1) {
                            bundleQty = quantity;
                        } else {
                            if (baseProductQty >= quantity) {
                                bundleQty = baseProductQty / quantity;
                            } else {
                                bundleQty = quantity / baseProductQty;
                            }
                        }
                        itemCountResult += bundleQty;
                    }
                } else {
                    itemCountResult += quantity;
                }
            }
            $('.v5-cart-item-count').attr('data-items-in-cart', itemCountResult)
            $('.v5-cart-item-count').text(itemCountResult);
            if(itemCountResult < 2) {
                $('.js_cart_total_items').html(`${itemCountResult} <span>item</span>`);
            } else {
                $('.js_cart_total_items').html(`${itemCountResult} <span>items</span>`);
            }
    }

    total() {
        return this.getData().then((data) => formatMoney(data.total_price, window.moneyFormat));
    }

    count() {
        return this.getData().then((data) => data.item_count);
    }

    removeFromCartBaseOn() {
        const cart = this.getData();
        const data = {updates: {}}
        cart.then((res) => {
            const shouldRemove = this.cartContainSpecificProduct(res.items);
            if(shouldRemove) {
                $('button[name="checkout"]').remove();
                for(const lineItem of res.items) {
                    if(lineItem.id != this.specificProductInCart) {
                        data.updates[lineItem.id] = 0;
                    }
                }
                if(Object.keys(data.updates).length > 0) {
                    this.api.cartUpdate(data).then(() => {
                        $('#free-shipping-pronugget').modal('show');
                    });
                }
            }
        });
    }

    cartContainSpecificProduct(lineItems) {
        if(lineItems.length === 1) return false;

        for(const lineItem of lineItems) {
            if(lineItem.id === this.specificProductInCart) {
                return true;
            }
        }
        return false;
    }

    // collectBundlePrice() {
    //     // this.fetch();
    //     this.api.cart().then((data) => {
    //         console.log(data);
    //     });
    //     const bundleLineItems = jQuery('.v4-cart-form').find('.bundled-item');
    //     let collectBundlePrice = [];
    //     for (const bundleLineItem of bundleLineItems) {
    //         const bundleName = jQuery(bundleLineItem).attr('data-bundle-id');
    //         const totalRowPrice = jQuery(bundleLineItem).find('.item-total2').attr('data-total-price');
    //         if (!collectBundlePrice[bundleName]) {
    //             collectBundlePrice[bundleName] = parseInt(totalRowPrice);
    //         } else {
    //             const bundlePrice = collectBundlePrice[bundleName] + parseInt(totalRowPrice);
    //             collectBundlePrice[bundleName] = bundlePrice;
    //         }
    //     }
    // }

    // updateBonusGiftCards() {
    //     const { data: { items } } = this;
    //     let updating = false;
    //
    //     /* Add up the total value of gift cards in the cart and figure out how
    //      * many bonus cards the customer should have. */
    //     let giftCardTotal = 0;
    //     const bonusCardLineItems = [];
    //     for (const item of items) {
    //         if (!item.gift_card)
    //             continue;
    //         if (item.product_id == BONUS_GIFT_CARD_PRODUCT_ID)
    //             bonusCardLineItems.push(item);
    //         else
    //             giftCardTotal += item.line_price;
    //     }
    //     const bonusCardsDue = Math.floor(giftCardTotal / BONUS_GIFT_CARD_PER_CENTS);
    //
    //     /* Maybe make an API call to add or remove bonus cards from the cart. */
    //     if (bonusCardLineItems.length === 0) {
    //         /* There are no bonus cards in the cart. If there should be, add one. */
    //         if (bonusCardsDue > 0) {
    //             this.addSingle(BONUS_GIFT_CARD_VARIANT_ID, bonusCardsDue);
    //             updating = true;
    //         }
    //     } else {
    //         /* There are one or more bonus cards in the cart. If none are due, delete them all.
    //          * If one or more are due, delete all but the last, and update the quantity of the
    //          * first appropriately. */
    //         const updates = {};
    //         let first = true;
    //         for (const item of bonusCardLineItems) {
    //             const { key, quantity } = item;
    //             if  (first) {
    //                 if (quantity != bonusCardsDue)
    //                     updates[key] = bonusCardsDue;
    //                 first = false;
    //             } else {
    //                 updates[key] = 0;
    //             }
    //         }
    //         if (Object.keys(updates).length !== 0) {
    //             this.update({ updates });
    //             updating = true;
    //         }
    //     }
    //
    //     return updating;
    // }
}
